import { useEffect } from 'react'

import { getBrandedTitle, useBranding } from './useBranding'

export function useTitle(newTitle) {
  const branding = useBranding()

  const baseTitle = getBrandedTitle(branding?.platformName)

  useEffect(() => {
    document.title = newTitle ? `${newTitle} › ${baseTitle}` : baseTitle

    return () => {
      document.title = baseTitle
    }
  }, [newTitle, baseTitle])
}
